//Resume.js
import React from 'react'
import { Text, View, Image, Button, ScrollView, SafeAreaView, Linking } from 'react-native'
import styles from './Styles.js'

//const border = 1;

const Resume = () => {
  return (
    <View>
      <Text> </Text>
      <Text style={styles.titleText}>Tutor of all subjects of elementary and high school, and exact sciences for high level.</Text>
      <Text style={styles.titleText}>Focused on International Baccalaureate Diploma Programme.</Text>
      <Text style={styles.titleText}>With 25 years experience in education for children, adolescents and young students.</Text>
      <Text style={styles.titleText}>Classes in Alphaville and region.</Text>
      <Text> </Text>
      <View style={styles.row}>
        <View style={{borderWidth: border, width: '50%'}}>
        </View>
        <View style={{borderWidth: border, width: '50%', borderLeftWidth: 1, borderLeftStyle: 'solid', borderLeftColor: '#666666'}}>
        <Text> </Text>
        <Text> </Text>
        <View style={{borderWidth: border, width: 60}}>
          <Text
            style={styles.linkBlack}
            onPress={() => Linking.openURL('mailto:marcioseno@hotmail.com')}
          >
            Email
          </Text>
        </View>
        <View style={{borderWidth: border, width: 90}}>
          <Text
            style={styles.linkBlack}
            onPress={() => Linking.openURL('http://bit.ly/3hVEwlY')}
          >
            WhatsApp
          </Text>
        </View>
        <View style={{borderWidth: border, width: 130}}>
          <Text
            style={styles.linkBlack}
            onPress={() => Linking.openURL('tel:${+5511999029313}')}
          >
            Phone in Brazil
          </Text>
        </View>
        <Text> </Text>
        <View style={{borderWidth: border, width: 80}}>
          <Text
            style={styles.link}
            onPress={() => Linking.openURL('https://www.linkedin.com/company/marcio-adriano-seno-aulas-particulares')}
          >
            LinkedIn
          </Text>
        </View>
        <View style={{borderWidth: border, width: 70}}>
          <Text
            style={styles.link}
            onPress={() => Linking.openURL('https://twitter.com/marcioseno')}
          >
            Twitter
          </Text>
        </View>
        <View style={{borderWidth: border, width: 90}}>
          <Text
            style={styles.link}
            onPress={() => Linking.openURL('https://www.instagram.com/marcioseno')}
          >
            Instagram
          </Text>
        </View>
        <View style={{borderWidth: border, width: 90}}>
          <Text
            style={styles.link}
            onPress={() => Linking.openURL('https://www.facebook.com/professoralphaville')}
          >
            Facebook
          </Text>
        </View>
        <View style={{borderWidth: border, width: 60}}>
          <Text
            style={styles.link}
            onPress={() => Linking.openURL('https://www.tiktok.com/@marcioseno')}
          >
            TikTok
          </Text>
        </View>
        <Text> </Text>
        <Text> </Text>
        </View>
      </View>
    </View>
  )
};
export default Resume;
